import { useContext, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import './StepperStartUp.css';
import {
  OptionTypes,
  ResponseInfo,
  initialResponseInfo,
} from "../../../../../../types/types";
import { StartUpStepperContext } from "../../StartUpStepperContext";
import { link_privacy, link_terms } from "../../../../../../../shared/const";
import YupPassword from "yup-password";
import Select from "react-select";
import { customStyles } from "../../../../../../../shared/style";
import clsx from "clsx";
import parse from "html-react-parser";
import { StepperHeader } from "../../../sharedComponents";
import { Button, Loader, Logo } from "../../../../../../atoms";
import useMediaQuery from "../../../../../../../hook/useMediaQuery";
import { MediaMobile, MediaTablet } from "../../../../../../../api/const/MediaQuery";
import { postRegisterStartup } from "api/calls/authCalls";
import { StartupRegisterRequest } from "components/types";
import { AppGeneralContext } from "shared/GeneralContext/GeneralContext";

YupPassword(Yup);

const responseInfoSchema = Yup.object().shape({
  option: Yup.object().shape({
    value: Yup.string().required("Please complete this required field."),
    label: Yup.string().required("Please complete this required field."),
  }),
  termsChecked: Yup.boolean().oneOf(
    [true],
    "The terms and conditions must be accepted."
  ),
  privacyChecked: Yup.boolean().oneOf(
    [true],
    "Please read and accept privacy."
  ),
});

export const StepResponse = (props: any) => {
  const { setErrorModal, setModalChildren,setLoadingModal, setClosedModal } = useContext(AppGeneralContext)
  const ctx = useContext(StartUpStepperContext);
  const tablet = useMediaQuery(MediaTablet)
  const mobile = useMediaQuery(MediaMobile)
  const [responseInfo] = useState<ResponseInfo>({
    ...initialResponseInfo,
  });
  const [imageLoaded, setImageLoaded] = useState(false)

  const formik = useFormik<ResponseInfo>({
    initialValues: responseInfo,
    validationSchema: responseInfoSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      setLoadingModal()

      ctx.setSelectedPlan(values.option);
      ctx.setTermsChecked(values.termsChecked);
      ctx.setPrivacyChecked(values.privacyChecked);

      const registerRequest: StartupRegisterRequest = {
        name: ctx.startUpName,
        vat: ctx.vatNumber,
        address: ctx.address,
        country: ctx.country,
        city: ctx.city,
        sdiPec: ctx.sdi,
        constitutionStatusId: ctx.state.value,
        sectorId: ctx.sector.value,
        planId: values.option.value,
        firstName: ctx.firstName,
        lastName: ctx.lastName,
        email: ctx.email,
        password: ctx.password,
        phoneNumber: ctx.phoneNumber,
      }

      var registerStartupResponse = await postRegisterStartup(registerRequest);
      setSubmitting(false)

      if (!registerStartupResponse.isSuccess || !registerStartupResponse.response) {
        setErrorModal(registerStartupResponse.error)
        props.firstStep()
        return
      }
      setClosedModal()
      props.nextStep()
    },
  });

  const openModalPlans = () => {
    setModalChildren({
      title: "Pick Your Plan",
      modalIsOpen: true,
      closeButton: true
    })
  }

  useEffect(() => {
    if (formik.values.option) {
      ctx.setGeneralInfo({ ...ctx.generalInfo, section1: formik.values.option?.htmlDescription ?? ""})
    }
  }, [formik.values.option])

  return (
    <div
      className={clsx(
        'pe-3 mt-3  ',
        { 'd-none': !props.isActive },
       
      )} >
      <StepperHeader stepperTitle="Billings" />

      <form onSubmit={formik.handleSubmit}  autoComplete='off'> 

        {/* option*/}
        <label className='text-black mt-3' htmlFor="firstName">Select your option <sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>

        <Select
          className="w-100"
          {...formik.getFieldProps("option")}
          onChange={(option) => formik.setFieldValue("option", option)}
          onBlur={() => formik.setFieldTouched("option", true)}
          options={ctx.plans}
          captureMenuScroll={true}
          placeholder="Select your plan"
          styles={customStyles}
          value={!!formik.values.option.label ? formik.values.option : null}
          components={{ IndicatorSeparator: () => null }}
        />
        {formik.errors.option && formik.touched.option && <div className='text-error ms-2' id="option">{formik.errors.option.value}</div>}
        <div className='d-flex justify-content-end'>
          <div onClick={() => openModalPlans()} className='link-primary-pink-sm'>Show Plans</div>
        </div>

        <p className="font-size-p mt-3 fw-400"> {parse(ctx.generalInfo.section1 ?? "")} </p>
        <p className="font-size-p fw-400"> {parse(ctx.generalInfo.section2)} </p>

        <div className="d-flex align-items-baseline">
          <input
            autoComplete="new-password"
            className="me-3"
            {...formik.getFieldProps("termsChecked")}
            onChange={formik.handleChange}
            type="checkbox"
            id="termsChecked"
            name="termsChecked"
            value="termsChecked"
          />
          <span className='font-size-p fw-400'>I declare that I accept the <a href={link_terms} target='_blank' rel="noreferrer" className='link-primary-pink-sm'>Terms and condition</a><sup className='text-error' style={{ fontSize: "16px" }}>*</sup></span>
        </div>
        {formik.errors.termsChecked && formik.touched.termsChecked && <div className='text-error ms-2' id="termsChecked">{formik.errors.termsChecked}</div>}


        <div className="d-flex align-items-baseline">
          <input
            autoComplete="new-password"
            className="me-3"
            {...formik.getFieldProps("privacyChecked")}
            onChange={formik.handleChange}
            type="checkbox"
            id="privacyChecked"
            name="privacyChecked"
            value="privacy" />
          <span className='font-size-p fw-400'>I declare to accept the <a href={link_privacy} target='_blank' rel="noreferrer" className='link-primary-pink-sm'>Privacy Policy</a><sup className='text-error' style={{ fontSize: "16px" }}>*</sup></span>
        </div>
        {formik.errors.privacyChecked && formik.touched.privacyChecked && <div className='text-error ms-2' id="privacyChecked">{formik.errors.privacyChecked}</div>}

        <p className='mt-3 font-size-p fw-400'> {parse(ctx.generalInfo.section3)} </p>

        <div className="d-flex flex-row justify-content-between mt-4 mb-4  stepper_navigator ">
          <button className=" stepper_navigator_btn  d-flex justify-content-start  align-items-center  h-100"
            onClick={() => { props.previousStep() }} >
            <Logo className="w-20 first me-2 rotate-180 " colorLogo="#FF3F6B" />
            <span> Back </span>
          </button>
          <div className="ms-1 me-1" />
          <div className="h-100 w-100  d-flex justify-content-end">
            <Button
              disabled={
                formik.isSubmitting
                || !formik.isValid
                || !formik.touched
              }

              type="submit"
              className=""
              color="var(--white)"
              background="var(--primary)"
              borderColor="var(--primary)"
              fontWeight={"800"}
              uppercase
              primary
              text="register"
            />
          </div>

        </div>
      </form>
    </div>
  );
};
